var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.config)?_c('AuthView',{attrs:{"form":_vm.config,"formLoading":_vm.loading},on:{"submit":_vm.onSubmit,"input":_vm.onInput}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }